export default function NotFound() {
  return <p>404</p>;
}
